import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/playstation': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3l-205.1 73.6v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9l-100.5 35.5v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9 0.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zM346.5 279.8v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8v-414.7c39.9 7.4 98 24.9 129.2 35.4 79.5 27.3 106.4 61.3 106.4 137.8 0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z'
      }
    ]
  }
})
